import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateAttendance } from "../../api/attendanceApi"; // Adjust the path to match your project structure

// Async thunk for adding attendance
export const updateAttendanceThunk = createAsyncThunk(
  "attendance/updateAttendance",
  async ({ attendanceData, attendanceId }, { rejectWithValue }) => {
    const AttendanceData = attendanceData;

    try {
      const response = await updateAttendance({
        AttendanceData,
        attendanceId,
      });
      if (!response.data.status) {
        throw response.data;
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

// Initial state
const initialState = {
  data: null, // Response data
  loading: false,
  error: null,
};

// Attendance slice
const updateAttendanceSlice = createSlice({
  name: "updateAttendance",
  initialState,
  reducers: {
    clearAttendanceState(state) {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAttendanceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAttendanceThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateAttendanceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

// Export actions and reducer
export const { clearAttendanceState } = updateAttendanceSlice.actions;
export default updateAttendanceSlice.reducer;
